import React from "react";
import { PageHeader, Section, Reveal } from "@/components/Section";

const quotes = [
  {
    text: "Devotional music, rebuilt in Dolby. KASHiX is redrawing the sonic map of bhakti.",
    source: "The Sonic Herald",
  },
  {
    text: "Aggressive, cinematic, unapologetically devotional — Sanskrit has never sounded this cool.",
    source: "Bass Culture Weekly",
  },
  {
    text: "The rare independent artist who treats production as prayer.",
    source: "Indie Signal India",
  },
];

const Press = () => (
  <>
    <PageHeader
      eyebrow="Press &amp; Media"
      hindi="प्रेस एवं मीडिया"
      title="Words on KASHiX"
      subtitle="Press assets, artist quotes and media enquiries. For interview requests, use the contact page."
    />
    <Section className="!py-16">
      <div className="grid gap-6 md:grid-cols-3">
        {quotes.map((q, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <blockquote className="glass rounded-2xl p-8 h-full flex flex-col">
              <div className="text-6xl font-display leading-none text-[#FF9933]/60 mb-4">“</div>
              <p className="font-editorial text-xl text-white/85 leading-relaxed flex-1">{q.text}</p>
              <footer className="mt-6 text-[10px] uppercase tracking-[0.35em] text-[#FF9933]">— {q.source}</footer>
            </blockquote>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <div className="mt-20 grid gap-6 md:grid-cols-2">
          <div className="glass rounded-2xl p-8">
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF9933]">Press Kit</div>
            <h3 className="mt-3 font-display text-2xl text-white">Assets, bios &amp; hi-res artwork</h3>
            <p className="mt-3 text-white/70">
              Journalists, curators and playlist editors — reach out on the contact page (choose “Press”) and
              a media kit will be sent within 24 hours.
            </p>
          </div>
          <div className="glass rounded-2xl p-8">
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF9933]">Booking &amp; Sync</div>
            <h3 className="mt-3 font-display text-2xl text-white">Live shows, film &amp; brand syncs</h3>
            <p className="mt-3 text-white/70">
              For live devotional experiences, film scoring collaborations and brand syncs — visit the
              Licensing page.
            </p>
          </div>
        </div>
      </Reveal>
    </Section>
  </>
);

export default Press;
